export var fileUploadQuestion = {
  __typename: 'FileUploadQuestion',
  id: '1',
  required: true,
  subject: 'Upload your favourite pdf.',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var dropdownQuestion = {
  __typename: 'DropdownQuestion',
  id: '2',
  required: false,
  subject: 'Choose your t-shirt size from the list below.  Note: they fit large.',
  options: [{
    description: 'Small'
  }, {
    description: 'Medium'
  }, {
    description: 'Large'
  }],
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var radioButtonQuestion = {
  __typename: 'RadioButtonQuestion',
  id: '3',
  required: false,
  subject: 'What colour of this item would you like?',
  options: [{
    description: 'Red'
  }, {
    description: 'Blue'
  }, {
    description: 'Yellow'
  }],
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var linkQuestion = {
  __typename: 'LinkQuestion',
  id: '4',
  required: false,
  subject: 'Which website do you want this item to come from?',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var ratingQuestion = {
  __typename: 'RatingQuestion',
  id: '5',
  required: false,
  subject: 'How would you rate your excitement for this reward?',
  points: 15,
  responseIsPublic: false,
  currentValue: '0'
};
export var shortAnswerQuestion = {
  __typename: 'ShortAnswerQuestion',
  id: '6',
  required: false,
  subject: 'Who would you like this item to be sent to?',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var checkboxQuestion = {
  __typename: 'CheckboxQuestion',
  id: '7',
  required: true,
  subject: 'What colours do you want in it?',
  options: [{
    description: 'Orange'
  }, {
    description: 'Purple'
  }, {
    description: 'Pink'
  }],
  points: 15,
  responseIsPublic: false,
  currentValues: []
};
export var longAnswerQuestion = {
  __typename: 'LongAnswerQuestion',
  id: '8',
  required: false,
  subject: 'Explain why you want this item. Include as much detail as you can so we know you really want it.',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var dateQuestion = {
  __typename: 'DateQuestion',
  id: '9',
  required: false,
  subject: 'What day is your birthday?',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var imageUploadQuestion = {
  __typename: 'ImageUploadQuestion',
  id: '10',
  required: true,
  subject: 'Upload a picture of your pet.',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};
export var videoUploadQuestion = {
  __typename: 'VideoUploadQuestion',
  id: '11',
  required: true,
  subject: 'Upload a Video of your pet.',
  points: 15,
  responseIsPublic: false,
  currentValue: ''
};